export { default } from './BancoAutoPesadoDesktop';
